import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CodingOpportunities/comment`;

/**
 * Crea un comentario para un Coding Opportunity.
 *
 * @param {Object} params
 * @param {number} params.codingOpportunityId - ID del coding opportunity
 * @param {number} params.employeeId - ID del empleado que crea el comentario
 * @param {string} params.authorRole - Rol del autor (e.g., "PCP", "CODER", "ADMIN")
 * @param {string} params.comment - Texto del comentario
 * @returns {Promise<Object>} - { message, commentId }
 */
const createCodingOpComment = async ({
  codingOpportunityId,
  employeeId,
  authorRole,
  comment,
}) => {
  try {
    const response = await axios.post(
      API_URL,
      {
        codingOpportunityId,
        employeeId,
        authorRole,
        comment,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating coding opportunity comment:", error);
    throw error;
  }
};

export default createCodingOpComment;
